<template>
  <div>
    <div class="">
      <ul class="nav nav-tabs">
        <li v-for="item in childsTab" :key="item.id" class="nav-item">
          <router-link
            :to="{name: 'Warehouse sc', params: {tab: currentTab, subTab: subTab ? item.id : null}}"
            :class="[item.active, item.disabled ? 'disabled' : '', checkDisabled(item)]"
            :disabled="item.disabled"
            >
            {{ item.title }}
          </router-link>
        </li>
      </ul>
      <div class="flexbox">
        <label v-for="item in childsTab" :key="item.id" :class="item.active" class="line"></label>
      </div>
    </div>
  </div>
</template>

<script>
import tabs from '@/common/warehouse-sc-tabs'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    },
    subTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      childsTab: []
    }
  },
  methods: {
    renderSubTabs () {
      let tab = tabs.find(item => item.id === this.currentTab)
      tab.active = 'active'
      this.childsTab = []
      if (tab.childs.length) {
        tab.childs.forEach((value) => {
          if (this.subTab === value.id) {
            value.active = 'active'
          } else {
            value.active = ''
          }
          if (this.subTab === 'edit-direct-delivery' && value.id === 'direct-delivery') {
            value.active = 'active'
          }
        })
        this.childsTab = tab.childs
      } else {
        this.childsTab.push(tab)
      }
    },
    checkDisabled (item) {
      if (this.subTab === 'edit-direct-delivery' && item.id === 'direct-delivery') {
        return 'disabled'
      }
      return ''
    }
  },
  watch: {
    currentTab () {
      this.renderSubTabs()
    },
    subTab () {
      this.renderSubTabs()
    }
  },
  mounted () {
    this.renderSubTabs()
  }
}
</script>
<style scoped>
.nav-tabs {
  border-bottom: unset;
}
.nav-item {
  text-align: center;
  width: 200px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-bottom: 3px solid #008cc6;
}
.nav-item a {
  color: #000;
  background-color: #fff;
}
.nav-item a.active {
  color: #fff;
  background-color: #008cc6;
}
.nav-tabs > li > a {
  margin-right: 0;
}
a.disabled {
  color: #bfbfbf;
  pointer-events: none;
}
.line::after {
  content: "";
  width: 200px;
  display: block;
  margin: 5px 0 0 0;
}
.active.line::after {
  border-bottom: 3px solid #008cc6;
}
@media screen and (max-width: 1024px) {
  .line {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/Subtab.vue